import React from 'react';
import { DateRow, InfoSection } from 'components';
import { CommentTypes, NotesMultipleModal } from '../../notesMultiple';
import { CANCELLED, DENIED, REJECTED } from '../../../pages/accounting/constants';
import { Images, useSecondaryModal } from 'utils';
import { createLoadStyle } from '../createFactoredLoad/core';

export const LoadErrAndNotes = ({loadById}) => {
  const classes = createLoadStyle();
  const { openSecondary } = useSecondaryModal({ noPadding: true, noCloseButton: true });

  const handleSeeAll = (commentType) => {
    if (commentType === CommentTypes.VERIFICATION) {
      openSecondary(
        <NotesMultipleModal
          id={loadById?.id}
          commentType={CommentTypes.VERIFICATION}
          svgSrc={Images.verificationNoteIcon}
        />,
      );
    } else {
      openSecondary(
        <NotesMultipleModal
          id={loadById?.id}
          commentType={CommentTypes.REVISION}
          svgSrc={Images.revisionNoteIcon}
        />,
      );
    }
  };

  return (
    <div>
      {loadById?.isVerification &&
        <div className={classes.notePadding}>
          <InfoSection
            infoText='Your load is currently under verification.'
            handleSeeAll={() => handleSeeAll(CommentTypes.VERIFICATION)}
          />
        </div>
      }

      {(loadById?.status === REJECTED || loadById?.status === DENIED) && loadById?.bill?.notes &&
        <div className={classes.rejectedLoad}>
          <img src={Images.rejectedLoad} alt='revisionNote' />
          <div className={classes.revisionNeededWrapper}>
            <p style={{ whiteSpace: 'nowrap' }}>Credit Rejected:&nbsp; </p>&nbsp;
            <p style={{ fontWeight: 400 }}> {loadById?.bill?.notes}</p>
          </div>
        </div>
      }

      {loadById?.isRevision &&
        <div className={classes.revisionNeeded}>
          <img src={Images.revisionNote} alt='revisionNote' />
          <div className={classes.revisionNeededWrapper}>
            <p> Your load is currently under revision. </p>

            <button className={classes.revisionNeededSeeAllBtn} onClick={handleSeeAll}>
              See All Notes
            </button>
          </div>
        </div>
      }

      {loadById?.status === CANCELLED &&
        <div className={classes.canceledLoad}>
          <img src={Images.error} alt='revisionNote' />
          <div className={classes.revisionNeededWrapper}>
            <p><b> Canceled </b></p>

            {loadById?.cancelledDate &&
              <p style={{ marginLeft: '16px' }}>
                <DateRow date={loadById?.cancelledDate} />
              </p>
            }
          </div>
        </div>
      }
    </div>
  )
};

